$(document).ready(function () {

    $('#pay-slider').owlCarousel({
        stagePadding: 100,
        loop:true,
        margin:0,
        nav:true,
        dots:false,
        items:1,
        lazyLoad: true,
        autoplay:true,
        autoplaySpeed: 1000,
        autoplayTimeout:11000,
        navText: [
          "<img src='" + assetBaseUrl + "images/banner-arrow.svg'>",
          "<img src='" + assetBaseUrl + "images/banner-arrow.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                stagePadding: 0,
                margin:5,
            },
            800:{
                items:1,
                stagePadding: 40,
            },
            1000:{
                items:1,
                stagePadding: 100,
            },
            1400:{
                items:1,
                stagePadding: 100,
            },
            1800:{
                items:1,
                stagePadding: 100,
            }
        }
    });
    $('#small-slider').owlCarousel({
        loop:true,
        margin:30,
        nav:false,
        dots:true,
        items:1,
        lazyLoad: true,
        autoplay:true,
        autoplaySpeed: 1000,
        autoplayTimeout:11000,
      responsive:{
            0:{
                items:1,
                margin:30,
            },
            800:{
                items:1,
            },
            1000:{
                items:1,
            },
            1400:{
                items:1,
            },
            1800:{
                items:1,
            }
        }
    }); 


    $('#apartments-section').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:3,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                nav:false,
                dots:true,
            },
            800:{
                items:1,
                margin:10,
                nav:false,
                dots:true,
            },
            1000:{
                items:3,
            },
            1400:{
                items:3,
            },
            1800:{
                items:3,
                nav:true  
            }
        }
    });

    $('.exp-slider-test').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                dots:true,
                nav:false,
            },
            800:{
                items:2,
                dots:false,
                nav:false,
            },
            1000:{
                items:3,
                nav:true    
            },
            1400:{
                items:4,
                nav:true  
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });
    $('#exp-slider2').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                dots:true,
                nav:false,
            },
            800:{
                items:2,
                dots:true,
                nav:false,
            },
            1000:{
                items:4,
            },
            1400:{
                items:4,
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });
    $('#exp-slider3').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                dots:true,
                nav:false,
            },
            800:{
                items:2,
                dots:true,
                nav:false,
            },
            1000:{
                items:4,
            },
            1400:{
                items:4,
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });
    $('#exp-slider4').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                dots:true,
                nav:false,
            },
            800:{
                items:2,
                dots:true,
                nav:false,
            },
            1000:{
                items:4,
            },
            1400:{
                items:4,
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });
    $('#testimonial-slider1').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                nav:false,
                dots:true,
            },
            800:{
                items:2,
            },
            1000:{
                items:4,
            },
            1400:{
                items:4,
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });
    $('#testimonial-slider2').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                nav:false,
                dots:true,
            },
            800:{
                items:2,
            },
            1000:{
                items:4,
            },
            1400:{
                items:4,
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });
    $('.exp-slider-demo').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:4,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                dots:true,
                nav:false,
            },
            800:{
                items:2,
                dots:true,
                nav:false,
            },
            1000:{
                items:4,
            },
            1400:{
                items:4,
            },
            1800:{
                items:4,
                nav:true  
            }
        }
    });

    $('#benefits-slider').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        items:3,
        lazyLoad: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 1000,
        navText: [
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
          "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                margin:15,
                dots:true,
                nav:false,
            },
            800:{
                items:2,
                dots:true,
                nav:true,
                margin:15,

            },
            1000:{
                items:2,
                margin:15,

            },
            1400:{
                items:3,
            },
            1800:{
                items:3,
                nav:true  
            }
        }
    });

    $('.modal-body').scroll(function() {
        var disable = $('#agreement').height() != ($(this).scrollTop() + $(this).height());
        $('#closeBtn').removeAttr('disabled', disable);
      });

      $("#openpdf").click(function () {
        $("#popup-pdf").addClass("showpdf");
    });
      $("#closeBtn,.pdf-close").click(function () {
        $("#popup-pdf").removeClass("showpdf");
      });


      if ($(window).width() <= 767) {
        $('#four-seasons').owlCarousel({
            loop:true,
            margin:30,
            nav:false,
            dots:true,
            items:1,
            lazyLoad: true,
            autoplay:true,
            autoplaySpeed: 1000,
            autoplayTimeout:11000,
 
        });   
        $('#aprt-slider').owlCarousel({
            loop:true,
            margin:30,
            nav:false,
            dots:true,
            items:1,
            lazyLoad: true,
            autoplay:true,
            autoplaySpeed: 1000,
            autoplayTimeout:11000,
 
        });   
      }




         /*Tabing section js */
    $('.wrap-tab .tab-btn').click(function(){
        var tab_id = $(this).attr('data-tab');
    
        $('.wrap-tab .tab-btn').removeClass('current');
        $('.tab-con-t').removeClass('current');
    
        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
        })
        /*Tabing section js */


        $(".mob-tab-opner").click(function(){  
            $(".membership-details").toggleClass("showdata");  
        });  
      
});